import {
    orgBillingTransferCheckoutSchema,
    orgBillingTransferRequestSchema,
    pendingOrgBillingTransferRequestResponseSchema,
} from "@common/dto/billing/org-billing-transfer-request.dto";
import {
    acceptOrgBillingTransferRequestBodySchema,
    declineOrgBillingTransferRequestBodySchema,
    orgBillingTransferRequestPathParamsSchema,
    pendingOrgBillingTransferRequestQuerySchema,
} from "@common/schemas/domains/billing/org-billing-transfer-request.schema";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { initContract } from "@ts-rest/core";

const c = initContract();

export const orgBillingTransferRecipientContract = c.router(
    {
        getPending: {
            path: "/pending",
            method: "GET",
            query: pendingOrgBillingTransferRequestQuerySchema,
            responses: {
                200: pendingOrgBillingTransferRequestResponseSchema,
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        checkout: {
            path: "/:requestId/checkout",
            method: "POST",
            pathParams: orgBillingTransferRequestPathParamsSchema,
            body: c.noBody(),
            responses: {
                200: orgBillingTransferCheckoutSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
                409: ErrorMessageSchema,
            },
        },
        accept: {
            path: "/:requestId/accept",
            method: "POST",
            pathParams: orgBillingTransferRequestPathParamsSchema,
            body: acceptOrgBillingTransferRequestBodySchema,
            responses: {
                200: orgBillingTransferRequestSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
                409: ErrorMessageSchema,
            },
        },
        decline: {
            path: "/:requestId/decline",
            method: "POST",
            pathParams: orgBillingTransferRequestPathParamsSchema,
            body: declineOrgBillingTransferRequestBodySchema,
            responses: {
                200: orgBillingTransferRequestSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
                409: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/org-billing-transfer-recipient-requests",
    },
);
